<template>
	<app-select
		:delay="500"
		:resolveOnLoad="!!$attrs.modelValue"
		:options="async (q) => await autocomplete(q, $attrs.modelValue)"
		:searchable="true"
		:filterResults="false"
		:clearOnSearch="true"
		:clearOnSelect="false"
		:placeholder="placeholder"
		:loading="loading"
		@select="$emit('update:modelValue', $event)"
		@deselect="$emit('update:modelValue', null)"
	/>
</template>

<script>
	import UserService from '@/services/UserService';

	export default {
		name: 'UserAutocomplete',
		data: () => ({
			loading: false,
		}),
		emits: ['update:modelValue'],
		props: {
			placeholder: {
				type: String,
				default: 'User',
			},
			userType: {
				type: Number,
				required: true,
			},
			status: {
				type: Number,
				default: null,
			},
			limit: {
				type: Number,
				default: 5,
			},
			offset: {
				type: Number,
				default: 0,
			},
		},
		methods: {
			autocomplete(text, id) {
				if ((text && text.length > 3) || id) {
					this.loading = true;
					return UserService.autocomplete({
						limit: this.limit,
						offset: this.offset,
						userType: this.userType,
						status: this.status,
						nameFilter: text,
						userId: !text ? id : -1,
					}).then((data) => {
						this.loading = false;
						return data;
					});
				}
			},
		},
	};
</script>
